<script setup lang="ts">
const t2 = useT2({})
const { myLink, linkProduct } = useLinks()

definePageMeta({
  middleware: (to, _) => {
    const all = to.name?.toString().includes('search-all') ? helpers.arrify(to.params.all) : undefined
    const slug = all?.at(0) === 'c' ? all.at(1) : undefined
    if (slug?.length) return navigateTo({ name: 'search-all', query: to.query, params: { all: [slug] } }, { redirectCode: 301 })
  },
})

const sellerId = useSellerId('retail')
const { options } = useCatalogQueryUpdate({
  sellerId: () => sellerId.value,
  isB2b: false,
  routeName: 'search',
  routeNameWithParams: myLink('search-all', {}).name?.toString() || '',
  toProductRoute: (i) => linkProduct(i),
  breadcrums: () => [
    { title: t2('Home'), to: myLink('index') },
    { title: t2('All Products'), to: myLink('search', {}) },
  ],
})
</script>

<template>
  <CatalogSearch :options />
</template>
